import React from 'react';
import { Container } from 'react-bootstrap';
import SprintSectionHeader from './sprint-section-header';

export default function SprintFlexCards({ 
    label, 
    titlePrefix, 
    highlightText, 
    titleSuffix, 
    subtitle, 
    items, 
    accentVariant = 'bottom', // 'bottom' or 'left'
    gridClass = '',
    sectionClass = 'sprint-why'
}) {
    return (
        <section className={sectionClass}>
            <Container>
                {label || titlePrefix || highlightText ? (
                    <SprintSectionHeader 
                        label={label}
                        titlePrefix={titlePrefix}
                        highlightText={highlightText}
                        titleSuffix={titleSuffix}
                        subtitle={subtitle}
                        center={true}
                    />
                ) : null}
                
                <div className={`sprint-why-grid ${gridClass}`}>
                    {items && items.map((item, idx) => (
                        <div className={`sprint-flex-card accent-${accentVariant} sprint-reveal sprint-delay-${(idx % 6) + 1}`} key={idx}>
                            <div className="sprint-flex-card-icon">{item.icon}</div>
                            <div className="sprint-flex-card-text">
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
